
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfigurationDropdownMenu',
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleDropdown(): void {
      this.isExpanded = !this.isExpanded
    },
    collapseDropdown(): void {
      this.isExpanded = false
    }
  }
})
